import React, { useState, useRef } from 'react';
import { helpHttp } from '../../helpers/helpHttp';
import { BASE_API } from '../../api/Globals';
//import { Button } from 'primereact/button';
//import { useFetch } from "../hooks/useFetch";
//import Loader from "../componentssturtural/Loader";
//import MessageDetail from "../../components/sturtural/MessageDetail";

const InputUpload = ({usuarioid, accept = '', handleSelection}) => {
    //const [file, setFile] = useState(null);

    const ref = useRef();

    const reset = () => {
        ref.current.value = "";
    };

    const selectedHandler = e => {
        //setFile(e.target.files);
        //convertirBase64();

        const file = e.target.files;

        Array.from(file).forEach(archivo => {
            let reader = new FileReader();
            reader.readAsDataURL(archivo);
            reader.onload = function () {

                let base64 = reader.result;

                //console.log(base64);
                //handleSelection(base64);

                //arrayAuxiliar = base64.split(',');
                //sendHandler(arrayAuxiliar[1]);

                let resized = null;
                reduce_image_file_size(base64).then(x => handleSelection(x));
                console.log(resized);
                
                //console.log(resized);
            }
        });
    }

    const reduce_image_file_size = async (base64Str, MAX_WIDTH = 720, MAX_HEIGHT = 720) => {
        let resized_base64 = await new Promise((resolve) => {
            let img = new Image()
            img.src = base64Str
            img.onload = () => {
                let canvas = document.createElement('canvas')
                let width = img.width
                let height = img.height
    
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width
                        width = MAX_WIDTH
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height
                        height = MAX_HEIGHT
                    }
                }
                canvas.width = width
                canvas.height = height
                let ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0, width, height)
                resolve(canvas.toDataURL()) // this will return base64 image results after resize
            }
        });
        return resized_base64;
    }

    /*const convertirBase64 = () => {
        console.log(file);

        Array.from(file).forEach(archivo => {
            let reader = new FileReader();
            reader.readAsDataURL(archivo);
            reader.onload = function () {

                let base64 = reader.result;

                console.log(base64);
                handleSelection(base64);

                //arrayAuxiliar = base64.split(',');
                //sendHandler(arrayAuxiliar[1]);
            }
        });
    }*/

    return (
        <>
            <input type="file" className="form-control" id="fileinput" accept={accept} onChange={selectedHandler} aria-label="Upload"  ref={ref} />
            {/* <Button className="p-button-rounded mr-2 mb-2" type="button" icon="pi pi-search" id="inputGroupFileAddon04" onClick={sendHandler}>Enviar</Button> */}
            {/*<Button type="button" className="p-button-rounded" onClick={() => convertirBase64()} label="Enviar" icon="pi pi-upload"  />*/}
        </>
    );  
}

export default InputUpload;